import Vue from 'vue'
import Router from 'vue-router'
import util from './util'

// views
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL && process.env.BASE_URL.startsWith('/') ? process.env.BASE_URL : '/',
  routes: [
    {
      path: '',
      name: 'home',
      component: Home,
    },
    {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
    },
    {
      path: '/:id',
      name: 'presentation',
      component: () => import(/* webpackChunkName: "presentation" */ './views/Presentation.vue'),
      children: [
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import(/* webpackChunkName: "feedback" */ './views/Feedback.vue'),
        },
        {
          path: 'review',
          name: 'lookback',
          component: () => import(/* webpackChunkName: "review" */ './views/Review.vue'),
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const accessToProfile = to.name === 'account' || to.name === 'profile'

  if (util.checkWhiteLabelDomain() && accessToProfile) {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router
